/**
 * FAQ Schema
 * Schema-driven settings with list
 */
export default {
  id: 'faq',
  version: 1,
  title: 'FAQ',
  description: 'Блок с часто задаваемыми вопросами в формате аккордеона',
  icon: 'HelpCircle',
  category: 'content',

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Часто задаваемые вопросы',
          defaults: { size: '3xl', weight: 'bold', color: 'foreground' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Опциональное описание...',
          multiline: true,
          rows: 2,
          defaults: { size: 'base', weight: 'normal', color: 'text-secondary' }
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'maxWidth',
          type: 'select',
          label: 'Ширина',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'sm', label: 'Узкая' },
            { value: 'md', label: 'Средняя' },
            { value: 'lg', label: 'Широкая' }
          ]
        }
      ]
    },
    {
      group: 'Вопросы',
      fields: [
        {
          key: 'items',
          type: 'list',
          label: 'Вопросы',
          addLabel: 'Добавить',
          itemLabel: 'Вопрос',
          maxItems: 20,
          itemFields: [
            {
              key: 'question',
              type: 'text',
              label: 'Вопрос',
              placeholder: 'Введите вопрос...',
              defaults: { size: 'base', weight: 'medium', color: 'foreground' }
            },
            {
              key: 'answer',
              type: 'text',
              label: 'Ответ',
              placeholder: 'Введите ответ...',
              multiline: true,
              rows: 3,
              defaults: { size: 'base', weight: 'normal', color: 'text-secondary' }
            }
          ]
        }
      ]
    }
  ],

  default: {
    title: { text: 'Часто задаваемые вопросы' },
    subtitle: { text: '' },
    items: [
      {
        id: 'faq-1',
        question: { text: 'Как забронировать рабочее место?' },
        answer: { text: 'Вы можете забронировать место через наш сайт или мобильное приложение. Выберите удобную дату и время, подтвердите бронирование.' }
      },
      {
        id: 'faq-2',
        question: { text: 'Какие способы оплаты доступны?' },
        answer: { text: 'Мы принимаем банковские карты, электронные кошельки и безналичную оплату для юридических лиц.' }
      }
    ],
    maxWidth: 'md'
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };

      // Migrate title/subtitle to text objects
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });

      // Migrate items
      if (migrated.items) {
        migrated.items = migrated.items.map((item, index) => ({
          id: item.id || `faq-${index + 1}`,
          question: typeof item.question === 'string' ? { text: item.question } : item.question,
          answer: typeof item.answer === 'string' ? { text: item.answer } : item.answer
        }));
      }

      return migrated;
    }
    return data;
  }
};
